import styles from './styles.less';


function FreewheelAd(props) {
    const className = cx(styles.freewheel, 'ad', props.className);
    return (
        <div
            className={ className }
            style={ props.style }>
            <span
                className='_fwph'
                id={ `SYNC_${props.id}` }>
                <form
                    id={ `_fw_form_SYNC_${props.id}` }
                    style={{ display: 'none' }}>
                    <input
                        type='hidden'
                        name={ `_fw_input_SYNC_${props.id}` }
                        id={ `_fw_input_SYNC_${props.id}` }
                        value={ `ptgt=${props.ptgt}&h=${props.height}&w=${props.width}&slau=${props.placement}` }
                    />
                </form>
                <span
                    className='_fwac'
                    id={ `_fw_container_SYNC_${props.id}` }>
                </span>
            </span>
        </div>
    );
}

FreewheelAd.propTypes = {
    height: React.PropTypes.number.isRequired,
    id: React.PropTypes.string.isRequired,
    placement: React.PropTypes.string.isRequired,
    ptgt: React.PropTypes.string.isRequired,
    width: React.PropTypes.number.isRequired
};

FreewheelAd.defaultProps = {
    height: 90,
    placement: '970x90_sync',
    ptgt: 's',
    width: 970
};


export default FreewheelAd;



/** WEBPACK FOOTER **
 ** ./src/common/components/ad/freewheel.js
 **/